import { useTranslation } from '@pancakeswap/localization'
import { TooltipBase } from '@/components/tooltips/base'

export const RouteModelTooltip = () => {
  const { t } = useTranslation()

  return <TooltipBase>{t('Routing through these tokens resulted in the best price for your trade.')}</TooltipBase>
}
